import React, { useState, useEffect } from 'react';
import { InfoCircle } from 'react-bootstrap-icons';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  const setCookie = (name, value, days = 365) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));

    const cookieString = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict;Secure`;
    document.cookie = cookieString;
  };

  useEffect(() => {
    if (!getCookie('cookieConsent')) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    setCookie('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleRejectNonEssential = () => {
    setCookie('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  // Inline styles matching website color palette
  const modalStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 9999,
    animation: 'slideInUp 0.3s ease-out',
  };

  const contentStyle = {
    backgroundColor: '#0B1221',
    borderRadius: '8px',
    padding: '24px',
    maxWidth: '380px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)',
    color: '#ffffff',
    border: '1px solid rgba(0, 194, 255, 0.15)',
  };

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '16px',
  };

  const titleStyle = {
    fontSize: '18px',
    fontWeight: '600',
    margin: 0,
    color: '#ffffff',
    lineHeight: '1.3',
    fontFamily: '"Inter", sans-serif',
  };

  const textStyle = {
    fontSize: '14px',
    lineHeight: '1.5',
    color: 'rgba(255, 255, 255, 0.8)',
    marginBottom: '20px',
    fontFamily: '"Inter", sans-serif',
  };

  const buttonsContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  };

  const acceptButtonStyle = {
    padding: '12px 20px',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textTransform: 'none',
    letterSpacing: '0.3px',
    backgroundColor: '#00C2FF',
    color: '#0B1221',
    fontFamily: '"Inter", sans-serif',
  };

  const rejectButtonStyle = {
    padding: '12px 20px',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textTransform: 'none',
    letterSpacing: '0.3px',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    color: 'rgba(255, 255, 255, 0.9)',
    fontFamily: '"Inter", sans-serif',
  };

  const animationStyle = `
    @keyframes slideInUp {
      from {
        transform: translateY(100px);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }

    @media (max-width: 768px) {
      .cookie-consent-modal-responsive {
        bottom: 10px !important;
        right: 10px !important;
        left: 10px !important;
        max-width: none !important;
      }

      .cookie-consent-content-responsive {
        max-width: 100% !important;
        padding: 20px !important;
      }
    }

    .cookie-consent-button-hover:hover {
      transform: translateY(-1px);
    }

    .cookie-consent-accept-hover:hover {
      background-color: #33cfff !important;
      box-shadow: 0 2px 8px rgba(0, 194, 255, 0.3);
    }

    .cookie-consent-reject-hover:hover {
      background-color: rgba(255, 255, 255, 0.1) !important;
      border-color: rgba(255, 255, 255, 0.3) !important;
    }
  `;

  return (
    <>
      <style>{animationStyle}</style>
      <div
        className="cookie-consent-modal-responsive"
        style={modalStyle}
      >
        <div
          className="cookie-consent-content-responsive"
          style={contentStyle}
        >
          <div style={headerStyle}>
            <InfoCircle
              style={{
                fontSize: '24px',
                color: '#00C2FF',
                flexShrink: 0
              }}
            />
            <h3 style={titleStyle}>Manage your cookie preference</h3>
          </div>
          <p style={textStyle}>
            Cookies enhance your experience and help us improve our website.
          </p>
          <div style={buttonsContainerStyle}>
            <button
              className="cookie-consent-button-hover cookie-consent-accept-hover"
              style={acceptButtonStyle}
              onClick={handleAcceptAll}
            >
              Accept All
            </button>
            <button
              className="cookie-consent-button-hover cookie-consent-reject-hover"
              style={rejectButtonStyle}
              onClick={handleRejectNonEssential}
            >
              Reject Non-Essential
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;
